module.exports = __webpack_public_path__ + "static/media/kyc_upgrade.37200059.svg";